export function parsePhoneNumber(value) {
  if (!value) return value;

  let cleanedValue = value.replace(/[()\s-+]/g, '');

  const extensionMatch = cleanedValue.match(/(x|e|ex|ext)\d*$/);
  const extension = extensionMatch ? extensionMatch[0] : '';

  cleanedValue = cleanedValue.replace(/[a-zA-Z].*$/, '');

  if (cleanedValue.length > 13) {
    cleanedValue = cleanedValue.slice(0, 13);
  }

  return cleanedValue + extension;
}
